import React, { useState } from "react";
import { NewInput } from "../..";
import { NewFieldStyles, NewFieldTypes, ValueSteps } from "../../../Definitions";
import { EditAbleCell, StyledTableCellProps } from "./styledTableCell";
import { IdentifiableRow } from "../reactiveTableRenderer";
import { CellContext } from "@tanstack/react-table";
import { focus_view } from "../../../Assets/Glyphs/focusView";

export interface StepOptions {
  valueStep: ValueSteps
}

export const NumberTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn, cell, valueStep}: CellContext<T, number | undefined> & EditAbleCell<T> & StepOptions) => {
  const initialValue = getValue();

  const [value, setValue] = useState(initialValue);

  const onBlur = () => {
    if (value !==initialValue) {
      table.options.meta?.updateData(row.original.id, column.id, value, row);
    }
  }

  const isStatic = typeof staticColumn === "function" ? staticColumn(row) : staticColumn;
  return <StyledNumberCell staticColumn={isStatic} key={cell.id} keyPass={cell.id+"Input"} onBlur={onBlur} onChange={(e: number) => setValue(e)} canEdit={canEdit} cellData={{value}} valueStep={valueStep}/>
}

const StyledNumberCell = <T extends IdentifiableRow> ({onBlur, onChange, canEdit, cellData, keyPass, staticColumn, valueStep, focus_view}: StyledTableCellProps & EditAbleCell<T> & {valueStep:ValueSteps} ) => {
  if (canEdit) {
    if (staticColumn) { 
      return (
        <div style={{ ...cellData.style, opacity: 0.5  }} key={keyPass}>
          {String(cellData.value) ?? ''}
        </div>
      );
    } else {
      return (
        <NewInput
          onBlur={onBlur}
          key={keyPass}
          onChange={onChange}
          fieldOverrides={{
            fieldStyle: NewFieldStyles.greyTertiary,
            fieldType: NewFieldTypes.tertiaryField,
            fieldWidth: "100%",
            focus_view: focus_view
          }}
          valueOverrides={{
            defaultValue: cellData.value,
            valueType: "number",
            valueStep: valueStep
          }}
        />
      );
    }
  }

  return (cellData.value)

}